import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import {
  ArchivedGivingAction,
  CreateGivingActionPayload,
  GetGivingActionsListProps,
  GivingAction,
  GivingActionsServiceCapabilities,
  UpdateGivingActionPayload
} from './givingActionsService.types'

export const givingActionsService = ({ percentClient }: GivingActionsServiceCapabilities) => ({
  getGivingActionsList: (params: GetGivingActionsListProps = {}) => {
    return percentClient.get<PBPListResponse<GivingAction>>(`${baseUrl}giving-actions`, { params })
  },
  getGivingAction: (actionId: string) => {
    return percentClient.get<PBPResponse<GivingAction>>(`${baseUrl}giving-actions/${actionId}`)
  },

  createGivingAction: ({ targetCountries, ...payload }: CreateGivingActionPayload) => {
    return percentClient.post<PBPResponse<GivingAction>>(`${baseUrl}partner/giving-actions`, {
      ...payload,
      ...(targetCountries != null && { targetCountries })
    })
  },
  updateGivingAction: ({ actionId, ...payload }: UpdateGivingActionPayload) => {
    return percentClient.patch<PBPResponse<GivingAction>>(`${baseUrl}partner/giving-actions/${actionId}`, payload)
  },
  archiveGivingAction: (actionId: string) => {
    return percentClient.delete<PBPResponse<ArchivedGivingAction>>(`${baseUrl}partner/giving-actions/${actionId}`)
  }
})
